import { useEffect, useState } from 'react';
import { Badge, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getBadgeCount } from '../../services/ApiGetBadge';
import { BadgeCount } from '../../model/datatype';
import { appConfig } from '../../authConfig';

export const Sidemenu = (props: any) => {
  const [pathname, setPathname] = useState('/');
  const location = useLocation();
  const date = new Date(); // date object
  const getYear = date.getFullYear(); // get current year
  const getMonth = date.getMonth() + 1; // get current year
  const [advSalaryRequest, setAdvSalaryRequest] = useState<BadgeCount | null>(
    null,
  );
  const hostname: string = window.location.pathname;

  useEffect(() => {
    localStorage.setItem('Language', 'en');
    setPathname(location.pathname);
    getBadgeCount(getYear, getMonth).then((response) => {
      setAdvSalaryRequest(response);
    });
  }, [location]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href =
      'https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=' + appConfig.appEndpoint.baseLocation;
  };

  function nFormatter(num: number) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
  }

  return (
    <>
      {props?.displayFullScreenLoading && (
        <div className="full-screen-overlay">
          <div className="loading"></div>
        </div>
      )}

      <div className="side-bar-menu">
        <div className="brand-logo">
          <h1>Consent</h1>
        </div>
        <ul>
          {hostname.includes('backoffice') ? (
            <>
              <li
                className={`${
                  pathname === '/backoffice' ||
                  pathname === '/backoffice/dashboard'
                    ? 'active'
                    : ''
                }`}
              >
                <Link to="/backoffice">
                  <img src="../../../images/backoffice/home.png" />
                  Adv.Salary Dashboard
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/schedulers' ? 'active' : ''
                }`}
              >
                <Link to="/backoffice/schedulers">
                  <img src="../../../images/backoffice/calendar.png" />
                  Salary Schedulers{' '}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/salary' ? 'active' : ''
                } badge-sytle`}
              >
                <Link to="/backoffice/salary">
                  <img src="../../../images/backoffice/user-plus.png" />
                  Adv.Salary Requests{' '}
                  {advSalaryRequest?.value > 0 ? (
                    <Badge bg="danger" className="badge">
                      {nFormatter(advSalaryRequest?.value)}
                    </Badge>
                  ) : (
                    <></>
                  )}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/payroll' ? 'active' : ''
                }`}
              >
                <Link to="/backoffice/payroll">
                  <img src="../../../images/backoffice/upload-cloud.png" />
                  Payroll Cutoff Uploader
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/anouncement' ? 'active' : ''
                }`}
              >
                <Link to="/backoffice/anouncement">
                  <img src="../../../images/backoffice/message-square.png" />
                  Annoucement
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          {hostname.includes('admconsent') ? (
            <>
              <li
                className={`${
                  pathname === '/admconsent/manage-consent' ? 'active' : ''
                }`}
              >
                <Link to="/admconsent/manage-consent">
                  <img src="../../../images/shield.png" />
                  PPT Consent
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          {hostname.includes('admuniform') ? (
            <>
              <li
                className={`${
                  pathname === '/admuniform/uniform-dashboard' ||
                  pathname === '/admuniform/uniform-dashboard'
                    ? 'active'
                    : ''
                }`}
              >
                <Link to="/admuniform/uniform-dashboard">
                  <img src="../../../images/backoffice/home.png" />
                  Dashboard
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/admuniform/uniform-summay' ? 'active' : ''
                }`}
              >
                <Link to="/admuniform/uniform-summay">
                  <img src="../../../images/backoffice/message-square.png" />
                  Summary{' '}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/admuniform/uniform-upload-benefit' ? 'active' : ''
                }`}
              >
                <Link to="/admuniform/uniform-upload-benefit">
                  <img src="../../../images/backoffice/upload-cloud.png" />
                  UploadBenefit{' '}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/admuniform/uniform-schedulers' ? 'active' : ''
                }`}
              >
                <Link to="/admuniform/uniform-schedulers">
                  <img src="../../../images/backoffice/message-square.png" />
                  Schedulers
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          <li onClick={() => handleLogout()}>
            <a href="#">
              <img src="../../../images/backoffice/log-out.png" />
              Logout
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};
